import {
    ChangeDetectionStrategy,
    Component,
    Injectable,
} from '@angular/core';
import {
    CredentialStoreResourceType,
    ICredentialStore,
    ICredentialStoreResource,
    ODataResponse,
} from '@models';
import {
    GRID_SERVICE,
    IGridSource,
    ODataGridComponent,
} from '@pages/generics/grid';
import {
    CredentialStoresService,
    ODataQueryOptions,
} from '@services';

@Injectable({
    providedIn: 'root',
})
export class AssetCredentialStoreResourcesSource implements IGridSource<ODataQueryOptions, ODataResponse<ICredentialStoreResource>> {
    public credentialStore!: ICredentialStore;
    public totalAssets?: number;

    public get mapper() {
        return this._credentialStore.mapper;
    }

    constructor(
        private _credentialStore: CredentialStoresService,
    ) { }

    public get(qo?: ODataQueryOptions) {
        return this._credentialStore.getResourcesForCredentialStore(
                this.credentialStore,
                CredentialStoreResourceType.AssetCredential,
                qo);
    }
}

@Component({
    selector: 'ui-asset-credential-store-resources-grid',
    templateUrl: './credential-store-resources.grid.html',
    providers: [{
        provide: GRID_SERVICE,
        useExisting: AssetCredentialStoreResourcesSource,
        deps: [
            CredentialStoresService,
        ],
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetCredentialStoreResourcesComponent
    extends ODataGridComponent<ICredentialStoreResource, number> { }
